import '../Section/section.css';
import T from 'i18n-react';
import { getIcon } from '../../../utils/IconUtil';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const SurveyLinkSection = ({ taxState, onSurveyClick }) => {
    const accountId = useSelector(state => state.accountData?.accountId);

    const handleSurveyClick = () => {
        const baseUrl = T.translate('WorkflowPanel.survey.url');
        
        const taxYear = taxState?.taxYear;
        const returnId = taxState?.workflow_state?.ticket_id;

        const url = new URL(baseUrl);
        
        if (taxYear) {
            url.searchParams.set('segment_3', taxYear.toString());
        }
        if (accountId) {
            url.searchParams.set('identifier', accountId.toString());
        }
        if (returnId) {
            url.searchParams.set('segment_4', returnId.toString());
        }

        if (onSurveyClick && returnId) {
            onSurveyClick(returnId);
        }

        window.open(url.toString(), '_blank');
    }

    return (
        <div className='survey-link-section-wrapper'>
            <div className='survey-link-section-icon'>
                <img src={getIcon('survey-section-icon')} />
            </div>
            <div className='survey-link-section-body'>
                <div className='survey-link-section-title'>
                    {T.translate('WorkflowPanel.survey.title')}
                </div>
                <div className='survey-link-section-text'>
                    {T.translate('WorkflowPanel.survey.subtext')}
                </div>
                <button className='survey-link-section-button' onClick={handleSurveyClick} >
                    <div className='survey-link-section-button-text'>{T.translate('WorkflowPanel.survey.button')}</div>
                </button>
            </div>
        </div>
    )
}

SurveyLinkSection.propTypes = {
    taxState: PropTypes.object,
    accountId: PropTypes.string,
    ticketId: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    postalCode: PropTypes.string,
    province: PropTypes.string,
    lang: PropTypes.string
}

SurveyLinkSection.propTypes = {
    taxState: PropTypes.object.isRequired,
    onSurveyClick: PropTypes.func
};

export default SurveyLinkSection;